module.exports = __webpack_public_path__ + "media/images/denis-4ea2eeeb9f0005ac103ec817a331406b.png";